<!-- Inset navigation (FEATURES.insetNav) or the classic dark side menu. Both list the same entries. -->
<ng-container *ngIf="features.insetNav; else classicShell">
  <ion-split-pane contentId="main" class="inset-shell" [ngClass]="{ minimise: splitPaneClosed }" (ionSplitPaneVisible)="onSplitPaneVisible($event)">
    <ion-menu contentId="main" menuId="main" class="nav-panel">
      <ion-header class="nav-header ion-no-border">
        <div class="nav-brand">
          <a [routerLink]="['/app/dashboard']" routerDirection="root" class="nav-logo" aria-label="FireDNA dashboard">
            <img src="./assets/img/logo-split-print.svg" class="nav-logo-mark" alt="" />
            <img src="./assets/img/logo-split-word.svg" class="nav-logo-word" alt="FireDNA" />
          </a>
          <button
            type="button"
            class="nav-collapse"
            (click)="toggleMenu()"
            [attr.aria-label]="splitPaneClosed ? 'Expand menu' : 'Minimise menu'"
            [pTooltip]="splitPaneClosed ? 'Expand menu' : 'Minimise menu'"
            tooltipPosition="right"
          >
            <fa-icon [icon]="['far', splitPaneClosed ? 'sidebar-flip' : 'sidebar']"></fa-icon>
          </button>
        </div>
      </ion-header>

      <ion-content class="nav-content" delegate-handle="content">
        <ng-container *ngIf="networkStatus$ | async as networkStatus">
          <ng-container *ngIf="{ value: updateAvailable$ | async } as updateAvailable">
            <nav aria-label="Main">
              <ion-menu-toggle auto-hide="false" class="nav-list">
                <a class="nav-item" [routerLink]="['/app/dashboard']" routerDirection="root" routerLinkActive="active" pTooltip="Dashboard" tooltipPosition="right" [tooltipDisabled]="!navCollapsed">
                  <fa-icon [icon]="['far', 'grid-2']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Dashboard</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/collection-manager']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRoleFromArray([Role.Customers]) && networkStatus.connected"
                  pTooltip="Customers"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'users']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Customers</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/collection-manager']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRoleFromArray([Role.Buildings, Role.Projects])"
                  pTooltip="Buildings"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'building']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Buildings</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/job-schedules']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="profile && profile.profileType !== 'Admin' && (hasRole(Role.JobSchedules) || profile.jobSchedulesEnabled)"
                  pTooltip="Job schedules"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'square-check']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Job schedules</span>
                </a>
                <!-- Smart views are evaluated server-side against the stats table — online only -->
                <a
                  class="nav-item"
                  [routerLink]="['/app/smart-views']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="features.smartViews && networkStatus.connected"
                  pTooltip="Smart views"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'eye']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Smart views</span>
                </a>
                <button type="button" class="nav-item" (click)="scanActionSheet()" *ngIf="hasRole(Role.Scan)" pTooltip="Scan to view" tooltipPosition="right" [tooltipDisabled]="!navCollapsed">
                  <fa-icon [icon]="['far', 'qrcode']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Scan to view</span>
                </button>
                <a
                  class="nav-item"
                  [routerLink]="['/app/admin/entities']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                  pTooltip="Entities"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'buildings']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Entities</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/admin/reporting']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                  pTooltip="Reporting"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'chart-line']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Reporting</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/generated-reports']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.EntityLevelReporting) && networkStatus.connected"
                  pTooltip="Generated reports"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'files']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Generated reports</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/public-report-signoff']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="features.publicSignoff && hasRole(Role.SignOff) && networkStatus.connected"
                  pTooltip="Public submission sign-off"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'check-double']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Public sign-off</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/admin/load-data']"
                  routerDirection="root"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                  pTooltip="Load data"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'cloud-arrow-up']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Load data</span>
                </a>
                <a
                  class="nav-item"
                  [routerLink]="['/app/settings']"
                  routerDirection="root"
                  [class.active]="settingsActive"
                  *ngIf="showSettings"
                  pTooltip="Settings"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'gear']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Settings</span>
                </a>
                <a
                  class="nav-item"
                  href="https://support.firedna.co.uk/"
                  target="_blank"
                  rel="noopener"
                  *ngIf="networkStatus.connected"
                  pTooltip="Help"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'circle-question']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Help</span>
                </a>
                <button
                  type="button"
                  class="nav-item"
                  (click)="offlineDataAlert()"
                  *ngIf="totalOfflineTransactions > 0 || !networkStatus.connected"
                  pTooltip="Offline data"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <span class="nav-icon-badge">
                    <fa-icon [icon]="['far', 'cloud-slash']" [fixedWidth]="true"></fa-icon>
                    <span class="nav-count">{{ totalOfflineTransactions }}</span>
                  </span>
                  <span class="nav-label">Offline data</span>
                </button>
                <button
                  type="button"
                  class="nav-item"
                  (click)="processImages()"
                  *ngIf="totalOfflineImages > 0 || !networkStatus.connected"
                  pTooltip="Offline images"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <span class="nav-icon-badge">
                    <fa-icon [icon]="['far', 'images']" [fixedWidth]="true"></fa-icon>
                    <span class="nav-count">{{ totalOfflineImages }}</span>
                  </span>
                  <span class="nav-label">Offline images</span>
                </button>
                <button
                  type="button"
                  class="nav-item nav-item-alert"
                  (click)="updateApp()"
                  *ngIf="updateAvailable.value"
                  pTooltip="Update available"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <fa-icon [icon]="['far', 'circle-exclamation']" [fixedWidth]="true"></fa-icon>
                  <span class="nav-label">Update available</span>
                </button>
                <button
                  type="button"
                  role="switch"
                  class="nav-item nav-offline"
                  data-testid="app-offline-toggle"
                  [attr.aria-checked]="!networkStatus.connected"
                  (click)="toggleAppOffline()"
                  *ngIf="isMobile || !networkStatus.connected"
                  pTooltip="Offline mode"
                  tooltipPosition="right"
                  [tooltipDisabled]="!navCollapsed"
                >
                  <span class="nav-switch" [class.on]="!networkStatus.connected"><span></span></span>
                  <span class="nav-label">Offline mode</span>
                </button>
              </ion-menu-toggle>
            </nav>
          </ng-container>
        </ng-container>
      </ion-content>

      <ng-container *ngIf="profile$ | async as profile">
        <ng-container *ngIf="messages$ | async as messages">
          <ion-footer class="nav-footer ion-no-border">
            <button
              type="button"
              class="nav-profile"
              (click)="presentProfileOverview()"
              [pTooltip]="profile.name"
              tooltipPosition="right"
              [tooltipDisabled]="!navCollapsed"
              aria-label="Open profile menu"
            >
              <span class="nav-avatar">
                <img *ngIf="profile.avatar?.length; else initials" src="{{ resizeFunctionUrl }}&height=125&blob={{ profile.avatar[0].fileName }}" alt="" />
                <ng-template #initials>{{ profileInitials(profile.name) }}</ng-template>
                <ng-container *ngIf="hasRole('messageService') || unreadMessageCount(messages) > 0">
                  <span class="nav-count" *ngIf="messages.messagesTo !== undefined">{{ unreadMessageCount(messages) }}</span>
                </ng-container>
              </span>
              <span class="nav-label nav-profile-text">
                <span class="nav-profile-name">{{ profile.name }}</span>
                <span class="nav-profile-type">{{ profile.profileType }}</span>
              </span>
            </button>
          </ion-footer>
        </ng-container>
      </ng-container>
    </ion-menu>

    <ion-router-outlet id="main" main>
      <div
        *ngIf="totalOfflineImages + totalOfflineTransactions > 0"
        class="safe-m-t rounded-full bg-red h-5 w-5 absolute top-1 right-2 z-[999999] flex items-center justify-center text-sm text-white"
      >
        {{ totalOfflineImages + totalOfflineTransactions }}
      </div>
      <ng-container *ngIf="showMFAbar">
        <div class="px-4 py-2 bg-blue text-white w-full absolute top-0 left-0 right-0 z-[999999] flex justify-between mfaBar">
          <div class="flex gap-2 cursor-pointer" (click)="enableMFA()">
            <fa-icon [icon]="['far', 'circle-info']" class=""></fa-icon> Click here to enable MFA security
          </div>
          <fa-icon [icon]="['far', 'circle-xmark']" class="text-lg" (click)="hideMFA()"></fa-icon>
        </div>
      </ng-container>
    </ion-router-outlet>
  </ion-split-pane>
</ng-container>

<ng-template #classicShell>
  <ion-split-pane contentId="main" class="group classic-shell" [ngClass]="{ minimise: splitPaneClosed }">
    <ion-menu contentId="main" menuId="main">
      <ion-header>
        <ion-item color="dark" class="p-0" lines="none">
          <div class="flex safe-m-t">
            <img src="./assets/img/logo-split-print.svg" class="h-[38px] mt-4 mb-6 transition" alt="logo-split-print" />
            <img
              src="./assets/img/logo-split-word.svg"
              class="h-[38px] mt-4 mb-6 ml-3 opacity-100 transition md:group-[.minimise]:opacity-0"
              alt="logo-split-word"
            />
          </div>
        </ion-item>
      </ion-header>

      <ion-content color="dark" delegate-handle="content">
        <ng-container *ngIf="networkStatus$ | async as networkStatus">
          <ng-container *ngIf="{ value: updateAvailable$ | async } as updateAvailable">
            <ion-list lines="none" class="bg-transparent sidebar-menu">
              <ion-menu-toggle auto-hide="false">
                <ion-item detail="false" [routerLink]="['/app/dashboard']" routerDirection="root" color="dark" routerLinkActive="active">
                  <ion-label>Dashboard</ion-label>
                  <ion-icon slot="start" name="apps" pTooltip="Dashboard"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/collection-manager']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRoleFromArray([Role.Customers]) && networkStatus.connected"
                >
                  <ion-label>Customers</ion-label>
                  <ion-icon slot="start" name="people-outline" pTooltip="Customers"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/collection-manager']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRoleFromArray([Role.Buildings, Role.Projects])"
                >
                  <ion-label>Buildings</ion-label>
                  <ion-icon slot="start" name="business-outline" pTooltip="Buildings"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/job-schedules']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="profile && profile.profileType !== 'Admin' && (hasRole(Role.JobSchedules) || profile.jobSchedulesEnabled)"
                >
                  <ion-label>Job schedules</ion-label>
                  <ion-icon slot="start" name="checkbox-outline" pTooltip="Job schedules"></ion-icon>
                </ion-item>
                <!-- Smart views are evaluated server-side against the stats table — online only -->
                <ion-item
                  detail="false"
                  [routerLink]="['/app/smart-views']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="features.smartViews && networkStatus.connected"
                >
                  <ion-label>Smart views</ion-label>
                  <ion-icon slot="start" name="eye-outline" pTooltip="Smart views"></ion-icon>
                </ion-item>
                <ion-item detail="false" (click)="scanActionSheet()" color="dark" routerLinkActive="active" *ngIf="hasRole(Role.Scan)" class="cursor-pointer">
                  <ion-label>Scan to view</ion-label>
                  <ion-icon slot="start" name="eye-outline" pTooltip="Scan to view"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/admin/entities']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                >
                  <ion-label>Entities</ion-label>
                  <ion-icon slot="start" name="business-outline" pTooltip="Entities"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/admin/reporting']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                >
                  <ion-label>Reporting</ion-label>
                  <ion-icon slot="start" name="analytics-outline" pTooltip="Reporting"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/generated-reports']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.EntityLevelReporting) && networkStatus.connected"
                >
                  <ion-label>Generated reports</ion-label>
                  <ion-icon slot="start" name="documents-outline" pTooltip="Generated reports"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/public-report-signoff']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="features.publicSignoff && hasRole(Role.SignOff) && networkStatus.connected"
                >
                  <ion-label>Public sign-off</ion-label>
                  <ion-icon slot="start" name="checkmark-done-outline" pTooltip="Public submission sign-off"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/admin/load-data']"
                  routerDirection="root"
                  color="dark"
                  routerLinkActive="active"
                  *ngIf="hasRole(Role.Admin) && networkStatus.connected"
                >
                  <ion-label>Load data</ion-label>
                  <ion-icon slot="start" name="cloud-upload-outline" pTooltip="Load data"></ion-icon>
                </ion-item>
                <ion-item
                  detail="false"
                  [routerLink]="['/app/settings']"
                  routerDirection="root"
                  color="dark"
                  [class.active]="settingsActive"
                  *ngIf="showSettings"
                >
                  <ion-label>Settings</ion-label>
                  <ion-icon slot="start" name="settings-outline" pTooltip="Settings"></ion-icon>
                </ion-item>
                <ion-item detail="false" color="dark" href="https://support.firedna.co.uk/" target="_blank" *ngIf="networkStatus.connected">
                  <ion-label>Help</ion-label>
                  <ion-icon slot="start" name="help-circle-outline" pTooltip="Help"></ion-icon>
                </ion-item>
                <ion-item detail="false" color="dark" (click)="offlineDataAlert()" *ngIf="totalOfflineTransactions > 0 || !networkStatus.connected">
                  <ion-label>Offline data</ion-label>
                  <ion-icon slot="start" name="cloud-offline-outline" pTooltip="Offline data"></ion-icon>
                  <ion-badge slot="start" color="danger" class="absolute left-2 bottom-0">{{ totalOfflineTransactions }}</ion-badge>
                </ion-item>
                <ion-item detail="false" color="dark" (click)="processImages()" *ngIf="totalOfflineImages > 0 || !networkStatus.connected">
                  <ion-label>Offline images</ion-label>
                  <ion-icon slot="start" name="cloud-offline-outline" pTooltip="Offline images"></ion-icon>
                  <ion-badge slot="start" color="danger" class="absolute left-2 bottom-0">{{ totalOfflineImages }}</ion-badge>
                </ion-item>
                <ion-item detail="false" color="dark" (click)="updateApp()" class="cursor-pointer" *ngIf="updateAvailable.value">
                  <ion-label>Update Available</ion-label>
                  <ion-icon slot="start" color="danger" name="alert-circle"></ion-icon>
                </ion-item>
                <ion-item data-testid="app-offline-toggle" detail="false" color="dark visible-inner" (click)="toggleAppOffline()" *ngIf="isMobile || !networkStatus.connected">
                  <p-toggleswitch
                    class="thin pointer-events-none w-9 mr-1"
                    [(ngModel)]="networkStatus.connected"
                    [trueValue]="false"
                    [falseValue]="true"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <ion-label class="offline-label">Offline mode</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>
            <div class="toggle-menu" (click)="toggleMenu()">
              <ion-icon name="chevron-back-outline" color="light"></ion-icon>
            </div>
          </ng-container>
        </ng-container>
      </ion-content>

      <ng-container *ngIf="networkStatus$ | async as networkStatus">
        <ng-container *ngIf="profile$ | async as profile">
          <ng-container *ngIf="messages$ | async as messages">
            <ion-footer class="profile-footer">
              <ion-item lines="none" color="darker" *ngIf="profile" (click)="presentProfileOverview()" class="mb-2 md:mb-0">
                <ion-avatar slot="start" *ngIf="profile.avatar?.length" class="with-badge">
                  <img src="{{ resizeFunctionUrl }}&height=125&blob={{ profile.avatar[0].fileName }}" alt="avatar" />
                  <ng-container *ngIf="hasRole('messageService') || unreadMessageCount(messages) > 0">
                    <ion-badge color="primary" *ngIf="messages.messagesTo !== undefined">{{ unreadMessageCount(messages) }}</ion-badge>
                  </ng-container>
                </ion-avatar>
                <ion-label>
                  <h2>{{ profile.name }}</h2>
                  <p class="strap">{{ profile.profileType }}</p>
                </ion-label>
                <ion-icon name="log-out-outline" slot="end" class="block md:hidden"></ion-icon>
              </ion-item>
              <!-- <p class="text-xs text-white opacity-50">{{currentApplicationVersion}}</p> -->
            </ion-footer>
          </ng-container>
        </ng-container>
      </ng-container>
    </ion-menu>

    <ion-router-outlet id="main" main>
      <div
        *ngIf="totalOfflineImages + totalOfflineTransactions > 0"
        class="safe-m-t rounded-full bg-red h-5 w-5 absolute top-1 right-2 z-[999999] flex items-center justify-center text-sm text-white"
      >
        {{ totalOfflineImages + totalOfflineTransactions }}
      </div>
      <ng-container *ngIf="showMFAbar">
        <div class="px-4 py-2 bg-blue text-white w-full absolute top-0 left-0 right-0 z-[999999] flex justify-between mfaBar">
          <div class="flex gap-2 cursor-pointer" (click)="enableMFA()">
            <fa-icon [icon]="['far', 'circle-info']" class=""></fa-icon> Click here to enable MFA security
          </div>
          <fa-icon [icon]="['far', 'circle-xmark']" class="text-lg" (click)="hideMFA()"></fa-icon>
        </div>
      </ng-container>
    </ion-router-outlet>
  </ion-split-pane>
</ng-template>
<ng-container *ngIf="{ syncInProgress: syncInProgress$ | async, datastoreSyncInProgress: datastoreSyncInProgress$ | async } as obs">
  <p-progressBar mode="indeterminate" *ngIf="obs.syncInProgress || obs.datastoreSyncInProgress" styleClass="global"></p-progressBar>
</ng-container>
